export enum SegmentNameEnum {
  'sidebar' = 'People - Menu - Page View',
  '/new' = 'People - Active Collaborator Send Spreadsheet - Page View',
  '/all' = 'People - Active Collaborator Listing - Page View',
  '/profile' = 'People - Active Collaborator Profile - Page View'
}

export enum SegmentTitlePage {
  '/all' = 'Listagem Colaboradores',
  '/new' = 'Importação de Colaboradores'
}

export enum SegmentEventName {
  'open_sidebar' = 'People - Menu - Page View',
  'click_link_employee_app' = 'People - Menu - Collaborator',
  'listing_empty' = 'People - Active Collaborator Import - Page View',
  'listing_export_button' = 'People - Active Collaborator Listing - Export Contributors',
  'listing_import_button' = 'People - Active Collaborator Listing - Import Collaborators',
  'import_send_speadsheet' = 'People - Active Collaborator Send Spreadsheet - Send Spreadsheet',
  'import_format_invalid' = 'People - Active Collaborator Error - Page View',
  'export_listing' = 'People - Active Collaborator Listing - Modal View',
  'export_listing_save' = 'People - Active Collaborator Listing - Export Collaborators Modal View',
  'export_listing_error' = 'People - Active Collaborator Listing - Error Modal View',
  'profile_active' = 'People - Active Collaborator Profile - Active User',
  'profile_export' = 'People - Active Collaborator Profile - Export',
  'document_details' = 'People - Collaborator Profile Signatures - Document Data Button Click',
  'document_opened' =  'People - Collaborator Profile Signatures - Visualize Button Click',
  'document_download' =  'People - Collaborator Profile Signatures - Download Button Click',
  'document_sidepanel' = 'People - Collaborator Profile - Document Info Side Panel View',
  'document_show_cpf' = 'People - Collaborator Profile Signatures - Show CPF Button Click',
  'shipping_document' = 'People - Collaborator Profile - Send Documments',
}

//tracking menu sidebar
export enum SegmentTrackMenu {
  'click_menu_candidates' = 'People - Collaborators Module - Menu - Candidates',
  'click_menu_listing' = 'People - Collaborators Module - Menu - Listing',
  'click_menu_import' = 'People - Collaborators Module - Menu - Import',
  'click_menu_history' = 'People - Collaborators Module - Menu - Import History',
}

//tracking list collaborators
export enum SegmentTrackList {
  'page_view_listing' = 'People - Collaborators Module - Collaborators list - Pageview',
  'click_button_import_empty_page' = 'People - Collaborators Module - Collaborators list - Import Collaborators Empty Button',
  'click_button_import' = 'People - Collaborators Module - Collaborators list - Import Collaborators Button',
  'click_tab_active' = 'People - Collaborators Module - Collaborators list - Active Tab Button',
  'click_tab_inactive' = 'People - Collaborators Module - Collaborators list - Inactive Tab Button',
}

//tracking import collaborators
export enum SegmentTrackImport {
  'page_view_import' = 'People - Collaborators Module - Import page - Pageview',
  'click_button_send_spreadsheet' = 'People - Collaborators Module - Import page - Send Spreadsheet',
  'click_button_download' = 'People - Collaborators Module - Import page - Template Spreadsheet Download Button',
  'import_invalid_format' = 'People - Collaborators Module - Import page - Invalid Format Error Message',
  'import_maximum_size' = 'People - Collaborators Module - Import page - Maximum Size Error Message',
  'import_column_error' = 'People - Collaborators Module - Import page - Changed Column Name Error Message',
  'import_send_failed' = 'People - Collaborators Module - Import page - Send Failed Error Message',
  'import_done' = 'People - Collaborators Module - Import page - Import Done Successfully Message',
  'import_send_worksheet_again' = 'People - Collaborators Module - Import page - Send Worksheet Again After Error Button',
  'download_send_worksheet_again' = 'People - Collaborators Module - Import page - Download Template Worksheet After Error Button'
}

//tracking history
export enum SegmentTrackHistory {
  'page_view_history' = 'People - Collaborators Module - Import History page - Pageview',
  'click_button_import_empty_page_history' = 'People - Collaborators Module - Import History page - Import Collaborator Button',
  'click_button_import_history' = 'People - Collaborators Module - Import History page - Import Collaborator Table Button',
  'click_button_action_eye' = 'People - Collaborators Module - Import History page - Action List Button',
  'click_button_report_error' = 'People - Collaborators Module - Import History page - Export Report Errors Button'
}
